// extracted by mini-css-extract-plugin
export default {"root":"BrandAnalyticsList_root__fQnyo","header":"BrandAnalyticsList_header__qd-60","search":"BrandAnalyticsList_search__39SDm","body":"BrandAnalyticsList_body__JxqQh"};